import type {
  BookCategory,
  BookModuleType,
  DifficultyLevel,
  SkillCategory,
  SkillLevel,
} from '@/types'

export const categoryColors: Record<SkillCategory, string> = {
  tech: 'bg-blue-100 text-blue-700',
  soft_skill: 'bg-green-100 text-green-700',
  industry: 'bg-purple-100 text-purple-700',
  career: 'bg-orange-100 text-orange-700',
}

export const categoryLabels: Record<SkillCategory, string> = {
  tech: 'Tech',
  soft_skill: 'Soft Skill',
  industry: 'Industry',
  career: 'Career',
}

export const difficultyColors: Record<DifficultyLevel, string> = {
  beginner: 'bg-green-100 text-green-700',
  intermediate: 'bg-yellow-100 text-yellow-700',
  advanced: 'bg-red-100 text-red-700',
}

export const difficultyLabels: Record<DifficultyLevel, string> = {
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
}

export const bookCategoryLabels: Record<BookCategory, string> = {
  career_development: 'Career Development',
  leadership: 'Leadership',
  communication: 'Communication',
  productivity: 'Productivity',
  technical: 'Technical',
  entrepreneurship: 'Entrepreneurship',
  personal_growth: 'Personal Growth',
  job_search: 'Job Search',
  networking: 'Networking',
  finance: 'Finance',
}

export const bookCategoryColors: Record<BookCategory, string> = {
  career_development: 'bg-blue-100 text-blue-700',
  leadership: 'bg-purple-100 text-purple-700',
  communication: 'bg-green-100 text-green-700',
  productivity: 'bg-yellow-100 text-yellow-700',
  technical: 'bg-indigo-100 text-indigo-700',
  entrepreneurship: 'bg-red-100 text-red-700',
  personal_growth: 'bg-teal-100 text-teal-700',
  job_search: 'bg-orange-100 text-orange-700',
  networking: 'bg-pink-100 text-pink-700',
  finance: 'bg-emerald-100 text-emerald-700',
}

export const bookModuleTypeLabels: Record<BookModuleType, string> = {
  key_takeaways: 'Key Takeaways',
  chapter_summaries: 'Chapter Summaries',
  flashcards: 'Flashcards',
  action_items: 'Action Items',
  career_application: 'Career Application',
}

export const bookModuleTypeEstimates: Record<BookModuleType, string> = {
  key_takeaways: '2 min',
  chapter_summaries: '10 min',
  flashcards: '5 min',
  action_items: '5 min',
  career_application: '5 min',
}

export const skillLevelValue: Record<SkillLevel, number> = {
  beginner: 1,
  intermediate: 2,
  advanced: 3,
  expert: 4,
}

export const skillLevelLabels: Record<SkillLevel, string> = {
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
  expert: 'Expert',
}
